export default __webpack_public_path__ + "static/media/long.e9fa9427.svg";